import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { focusOutline } from '../utils/focusOutline';
import { visuallyHidden } from '../utils/visuallyHidden';
import { Box } from '../Box';
export const RadioElement = forwardRef(function RadioElement({ name, id, value, isDisabled, checked, onChange, onBlur, isError, ...marginProps }, ref) {
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInput, { ref: ref, type: "radio", name: name, id: id, value: `${value}`, checked: checked, onChange: () => onChange(value), onBlur: onBlur, disabled: isDisabled }),
        React.createElement(RadioCircle, { "$isError": isError, "$checked": checked, ...marginProps })));
});
const StyledInput = styled.input `
  ${visuallyHidden}
`;
const RADIO_SIZE = 24;
const RadioCircle = styled(Box) `
  flex-shrink: 0;
  width: ${RADIO_SIZE}px;
  height: ${RADIO_SIZE}px;
  border-radius: ${RADIO_SIZE}px;
  background-color: ${theme.colors.cream};
  border: 2px solid
    ${({ $isError }) => $isError ? theme.colors.strawberry : theme.colors.sesame};

  ${({ $checked, $isError }) => !$checked &&
    !$isError &&
    `
    &:hover {
      border: 2px solid ${theme.colors.liquorice};
    }
  `}

  ${({ $checked, $isError }) => $checked &&
    `border: 8px solid ${$isError ? theme.colors.strawberry : theme.colors.liquorice};`}

  ${focusOutline({ selector: `${StyledInput}:focus-visible + &` })}
`;
//# sourceMappingURL=RadioElement.js.map